export const strings = {
    prefixAgo: 'for',
    prefixFromNow: 'om',
    suffixAgo: 'siden',
    suffixFromNow: '',
    seconds: 'mindre end et minut',
    minute: 'ca. et minut',
    minutes: '%d minutter',
    hour: 'ca. en time',
    hours: 'ca. %d timer',
    day: 'en dag',
    days: '%d dage',
    month: 'ca. en måned',
    months: '%d måneder',
    year: 'ca. et år',
    years: '%d år',
};
